var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('Heading'),_c('ProfilePage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }